import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CommonModule, registerLocaleData } from '@angular/common';
import { authInterceptorProviders } from './_helpers/auth.interceptor';
import { AlertaObjetoFinanciable, Certificado, Modalinfo, Excedido, HomeComponent, Inicio, Legal2, Legal3, Legal4, Legal5, Pyme } from './home/home.component';
import { SimuladorComponent } from './simulador/simulador.component';

import { MatSliderModule } from '@angular/material/slider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatStepperModule } from '@angular/material/stepper';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import localeAr from '@angular/common/locales/es-AR';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CustomHttpInterceptor } from './_helpers/customHttpInterceptor';
import { NgbModule, NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { MensajeImportanteComponent } from './mensaje-importante/mensaje-importante.component';


registerLocaleData(localeAr);

@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        Certificado,
        Modalinfo,
        Excedido,
        AlertaObjetoFinanciable,
        Pyme,
        Inicio,
        Legal2,
        Legal3,
        Legal4,
        Legal5,
        SimuladorComponent,
        MensajeImportanteComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpClientModule,
        CommonModule,
        ReactiveFormsModule,
        MatSliderModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatNativeDateModule,
        MatInputModule,
        MatStepperModule,
        MatButtonModule,
        MatIconModule,
        MatTableModule,
        MatExpansionModule,
        MatCheckboxModule,
        MatTooltipModule,
        MatSelectModule,
        MatDialogModule,
        CurrencyMaskModule,
        MatToolbarModule,
        MatProgressSpinnerModule,
        NgbModule,
        NgbToastModule
    ],
    providers: [authInterceptorProviders,
        {provide: LOCALE_ID, useValue: 'es-AR'},
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CustomHttpInterceptor,
            multi: true
        }],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]

})
export class AppModule {
}
